export default "__VITE_ASSET__CEYl8cjE__"